import React from 'react'
import Profile_AV from "../../../../../assets/images/avatar.png"

// Main component for the Edit Profile Tab
const EditProfileTab = () => {

    // SVG for the edit button displayed on the profile image
    const profileImageEditButton = (
        <svg width="20" viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip-two)">
                <path d="M14.587 4.16309L13.2364 5.51367C13.0987 5.65137 12.876 5.65137 12.7383 5.51367L9.48637 2.26172C9.34867 2.12402 9.34867 1.90137 9.48637 1.76367L10.837 0.413086C11.3848 -0.134766 12.2754 -0.134766 12.8262 0.413086L14.587 2.17383C15.1377 2.72168 15.1377 3.61231 14.587 4.16309ZM8.32621 2.92383L0.632851 10.6172L0.011757 14.1768C-0.073204 14.6572 0.345741 15.0732 0.82621 14.9912L4.38578 14.3672L12.0791 6.67383C12.2168 6.53613 12.2168 6.31348 12.0791 6.17578L8.82719 2.92383C8.68656 2.78613 8.46391 2.78613 8.32621 2.92383ZM3.63578 9.95801C3.47465 9.79688 3.47465 9.53906 3.63578 9.37793L8.1475 4.86621C8.30863 4.70508 8.56644 4.70508 8.72758 4.86621C8.88871 5.02734 8.88871 5.28516 8.72758 5.44629L4.21586 9.95801C4.05473 10.1191 3.79691 10.1191 3.63578 9.95801ZM2.57816 12.4219H3.98441V13.4854L2.09476 13.8164L1.18363 12.9053L1.51469 11.0156H2.57816V12.4219Z"
                    fill="white"></path>
            </g>
            <defs>
                <clipPath id="clip-two">
                    <rect width="15" height="15"
                        fill="white"></rect>
                </clipPath>
            </defs>
        </svg>
    )

    return (
        // Main container with responsive grid layout
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 my-3 pt-5">
            {/* Left column for profile image and edit button */}
            <div className="col-span-1 lg:col-span-3 flex flex-col items-center py-5">
                <div className="profile-pic">
                    {/* Button overlay on profile image for editing */}
                    <div className="absolute z-10 end-0 bottom-0 rounded-full bg-primary p-2 ">
                        {profileImageEditButton}
                    </div>
                    {/* Label for image upload input */}
                    <label className="-label flex content-center" htmlFor="file">
                        <span className="glyphicon glyphicon-camera"></span>
                        <span>Change Image</span>
                    </label>
                    {/* Hidden file input for profile picture upload */}
                    <input id="file" type="file" />
                    {/* Displayed profile image */}
                    <img src={Profile_AV} id="output" width="200" alt="profile-photo-two" />
                </div>
            </div>

            {/* Right column for form fields */}
            <div className="col-span-1 lg:col-span-9">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Form fields for profile information */}
                    <div>
                        <label htmlFor="name" className="block text-dark text-sm mb-2">Your Name</label>
                        <input type="text" id='name' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="Charlene Reed" autoComplete='off' />
                    </div>
                    <div>
                        <label htmlFor="username" className="block text-dark text-sm mb-2">User Name</label>
                        <input type="text" id='username' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="Charlene Reed" autoComplete='off' />
                    </div>
                    <div>
                        <label htmlFor="email" className="block text-dark text-sm mb-2">Email</label>
                        <input type="email" id='email' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="charlenereed@gmail.com" autoComplete='off' />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-dark text-sm mb-2">Password</label>
                        <input type="password" id='password' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="**** ****" />
                    </div>
                    <div>
                        <label htmlFor="dob" className="block text-dark text-sm mb-2">Date of Birth</label>
                        <input type="text" id='dob' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="25 January 1990" />
                    </div>
                    <div>
                        <label htmlFor="add" className="block text-dark text-sm mb-2">Present Address</label>
                        <input type="text" id='add' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="San Jose, California, USA" />
                    </div>
                    <div>
                        <label htmlFor="Permanentadd" className="block text-dark text-sm mb-2">Permanent Address</label>
                        <input type="text" id='Permanentadd' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="San Jose, California, USA" />
                    </div>
                    <div>
                        <label htmlFor="city" className="block text-dark text-sm mb-2">City</label>
                        <input type="text" id='city' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="San Jose" />
                    </div>
                    <div>
                        <label htmlFor="pincode" className="block text-dark text-sm mb-2">Postal Code</label>
                        <input type="text" id='pincode' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="45962" />
                    </div>
                    <div>
                        <label htmlFor="country" className="block text-dark text-sm mb-2">Country</label>
                        <input type="text" id='country' className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0" placeholder="USA" autoComplete='off' />
                    </div>
                </div>
                {/* Save button */}
                <button type="submit" className="bg-primary-900 text-white hover:bg-primary-800 rounded-lg py-2 px-10 w-full md:w-auto mt-3">Save</button>
            </div>
        </div >
    )
}

export default EditProfileTab
